import { IconName } from "PFTheme/graphics/icons";
import { MatchPreference } from "PFTypes";

export const PREFERENCE_ICON_TABLE: Record<MatchPreference, IconName> = {
  [MatchPreference.Skills]: "core",
  [MatchPreference.Type]: "department",
  [MatchPreference.Duration]: "clock"
};
